import React from "react";
import { Link } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Add from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import get from "lodash/get";

const PageToolbar = styled(Grid)({
    marginBottom: "20px",
    marginTop: "20px",
});

const LeftIcon = styled(Grid)({
    marginLeft: "25px",
});

const LinkButtonStyle = styled(Link)({
    textDecoration: "none",
});

const TransactionsToolbar = (props) => {
    const { filterQuery, addNewTransaction, transactionsTab, numTransactions } = props;

    return (
        <PageToolbar container justifyContent="space-between" alignItems="center" spacing={16}>
            <Grid item>
                <h2 className="page-title">Transactions</h2>
                <div style={{ fontSize: "14px" }}>
                    {`Showing ${get(numTransactions, transactionsTab, 0)} ${
                        numTransactions[transactionsTab] === 1 ? "transaction" : "transactions"
                    } `}
                    {filterQuery > "" && "(Filtered)"}
                </div>
            </Grid>
            <Grid item>
                <Grid container alignItems="center" spacing={0}>
                    <LeftIcon item>
                        <LinkButtonStyle
                            to={{
                                pathname: "/transactions/create",
                                state: { newTransaction: true },
                            }}
                        >
                            <Button variant="contained" color="primary" onClick={addNewTransaction}>
                                <Add /> Create New Transaction
                            </Button>
                        </LinkButtonStyle>
                    </LeftIcon>
                </Grid>
            </Grid>
        </PageToolbar>
    );
};

export default TransactionsToolbar;
